import NoteContainer from './NoteContainer';
import dayjs from "dayjs";
import {db} from "../firebase";
import {remove, update, ref} from "firebase/database";

function Notes({notesFiltred, setShowModal, setActiveNote, type}) {  
  function onDelete(e, id) {
    e.stopPropagation();

    window.confirm("Delete this note?") && remove(ref(db, `/${id}`));
  }

  function onArchive(e, id) {
    e.stopPropagation();

    const date = new Date();

    update(ref(db, `/${id}`), {
      status: "archive",
      updateDate: dayjs(date).format('MMMM DD, HH:mm:ss A'),
    });
  }
  
  return (
    <div>
      {notesFiltred.length > 0 && <h2 className="title-h2">{type} notes</h2>}
      <ul className="notes-list">
      {
        notesFiltred.map((note) => {
          return (
            <NoteContainer 
              key={note.id} 
              onDelete={onDelete}
              onArchive={onArchive}
              setShowModal={setShowModal}
              setActiveNote={setActiveNote}
              {...note}/>
            )
          })
        }
      </ul>
    </div>
  );
}

export default Notes;